import { Link } from 'react-router-dom';
import './Home.css';

const services = [
  { icon: '🤖', title: 'Agentes IA para Ventas', desc: 'Automatiza seguimiento de leads, cotizaciones y cierre de ventas con agentes entrenados para tu negocio.' },
  { icon: '💬', title: 'Atención al Cliente IA', desc: 'Chatbots inteligentes que responden 24/7, resuelven dudas y escalan casos complejos a tu equipo.' },
  { icon: '📊', title: 'Análisis de Datos', desc: 'Convierte tus datos en decisiones. Dashboards automáticos e informes generados con inteligencia artificial.' },
  { icon: '🏛️', title: 'Sector Público', desc: 'Transformación digital para alcaldías y entidades departamentales. Gobierno eficiente con IA.' },
];

const stats = [
  { value: '10+', label: 'Municipios asesorados' },
  { value: '24/7', label: 'Agentes activos' },
  { value: '3x', label: 'Productividad promedio' },
  { value: '100%', label: 'Compromiso regional' },
];

export default function Home() {
  return (
    <main className="home">

      {/* HERO */}
      <section className="hero">
        <div className="hero__bg">
          <div className="hero__orb hero__orb--1" />
          <div className="hero__orb hero__orb--2" />
          <div className="hero__grid" />
        </div>
        <div className="container hero__content">
          <div className="tag animate-fade-up">Inteligencia Artificial · Tolima · Colombia</div>
          <h1 className="hero__title animate-fade-up delay-1">
            La IA que transforma<br />
            <span className="hero__title--accent">tu empresa</span>
          </h1>
          <p className="hero__subtitle animate-fade-up delay-2">
            Implementamos agentes de inteligencia artificial para empresas e instituciones públicas.<br />
            Automatización real, resultados medibles.
          </p>
          <div className="hero__actions animate-fade-up delay-3">
            <Link to="/contacto" className="btn-primary">Agendar llamada gratuita →</Link>
            <Link to="/servicios" className="btn-outline">Ver servicios</Link>
          </div>
        </div>
        <div className="hero__scroll">
          <div className="hero__scroll-line" />
        </div>
      </section>

      {/* STATS */}
      <section className="stats section-sm">
        <div className="container">
          <div className="stats__grid">
            {stats.map((s, i) => (
              <div className="stats__item" key={i}>
                <span className="stats__value">{s.value}</span>
                <span className="stats__label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SERVICIOS */}
      <section className="home-services section">
        <div className="container">
          <div className="section-header">
            <div className="tag">Servicios</div>
            <h2 className="section-title">IA que trabaja<br />para tu negocio</h2>
            <p className="section-sub">Soluciones prácticas de inteligencia artificial diseñadas para el contexto empresarial colombiano.</p>
          </div>
          <div className="services-grid">
            {services.map((s, i) => (
              <div className="service-card" key={i}>
                <div className="service-card__icon">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <Link to="/servicios" className="service-card__link">Conocer más →</Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* DIFERENCIADOR */}
      <section className="differentiator section">
        <div className="container">
          <div className="diff__inner">
            <div className="diff__content">
              <div className="tag">¿Por qué KAIROS AI?</div>
              <h2 className="section-title">Experiencia institucional<br />+ tecnología de punta</h2>
              <p className="diff__text">
                Somos la única consultora de IA en el Tolima con experiencia directa en gobierno digital. Nuestro fundador fue Enlace Regional de MinTIC y Líder TIC de Alcaldía Municipal — conocemos desde adentro cómo funcionan las entidades públicas y las PyMEs de la región.
              </p>
              <ul className="diff__list">
                <li>✦ Conocimiento de política pública TIC y normatividad colombiana</li>
                <li>✦ Soluciones adaptadas al presupuesto y contexto regional</li>
                <li>✦ Acompañamiento completo: estrategia, implementación y capacitación</li>
              </ul>
              <Link to="/nosotros" className="btn-primary" style={{marginTop: '8px'}}>Conocer al equipo →</Link>
            </div>
            <div className="diff__visual">
              <div className="diff__card diff__card--main">
                <div className="diff__card-icon">🧠</div>
                <h4>IA Aplicada</h4>
                <p>No vendemos tecnología — implementamos soluciones que generan resultados reales en tu operación diaria.</p>
              </div>
              <div className="diff__card diff__card--sub">
                <div className="diff__card-icon">🏛️</div>
                <h4>Sector Público</h4>
                <p>Expertos en transformación digital para entidades territoriales del Tolima.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="home-cta section-sm">
        <div className="container">
          <div className="cta-box">
            <div className="cta-box__orb" />
            <div className="tag">Siguiente paso</div>
            <h2>¿Listo para automatizar<br />tu empresa con IA?</h2>
            <p>Agenda una llamada gratuita de 30 minutos. Analizamos tu negocio y te mostramos qué puede hacer la IA por ti.</p>
            <Link to="/contacto" className="btn-primary">Agendar llamada gratuita →</Link>
          </div>
        </div>
      </section>

    </main>
  );
}
